module.exports = __webpack_public_path__ + "img/successStory10.86ad556f.jpg";